import React, { useState, useEffect } from 'react'
import { Box, Flex, Button, Modal, Text } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { getPackageShipmentList, updatePackageShipment, deletePackageShipment, updatePackageShipmentDocument } from '../../../../services/package'
import { useParams, useNavigate } from 'react-router-dom'
import NoData from '../../../ui/NoData'
import LoadingData from '../../../ui/LoadingData'
import OrderPackageShipmentTable from './LayoutHelper/OrderPackageShipmentTable'
import FormAdjustPackageShipment from './Form/FormAdjustPackageShipment'
import FormAdjustHandleShipment from './Form/FormAdjustHandleShipment'
import FormAdjustShippingDocument from './Form/FormAdjustShippingDocument'
import FormBroadcastPackageShipment from './Form/FormBroadcastPackageShipment'
import FormSharePackageShipment from './Form/FormSharePackageShipment'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'
import { modalDeleteDataUsePayload } from '../../../ui/Prompt/modalDeleteDataUsePayload'

const labelTable = [
  {
    label: 'ID',
    width: 'auto'
  },
  {
    label: 'Name',
    width: 'auto'
  },
  {
    label: 'First Mile',
    width: 'auto'
  },
  {
    label: 'Last Mile',
    width: 'auto'
  },
  {
    label: 'Who Handle Shipping ?',
    width: 'auto'
  },
  {
    label: 'Specific Shipping Label (if Any)',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Updated By',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const OrderPackageShipment = () => {
  const navigate = useNavigate()
  const params = useParams()
  const orderId = params.order_id
  const [loading, setLoading] = useState(true)
  const [packageShipmentList, setPackageShipmentList] = useState([])
  const [modalFormPackageShipment, setModalFormPackageShipment] = useState(false)
  const [modalFormHandleShipment, setModalFormHandleShipment] = useState(false)
  const [modalFormShippingDocument, setModalFormShippingDocument] = useState(false)
  const [modalFormBroadcast, setModalFormBroadcast] = useState(false)
  const [modalFormShareTracking, setModalFormShareTracking] = useState(false)
  const [detailData, setDetailData] = useState(null)


  const handleGetPackageShipmentList = async () => {
    setLoading(true)
    const params = {
      'filter[order_id][is]': orderId,
      'include': 'packaging,images,supplier,warehouse,creator,updater,documents',
      timestamp: `${new Date().getTime()}`
    }
    try {
      const response = await getPackageShipmentList(params)
      if (response.success) {
        const dataPackageShipment = response.data
        const pickIncludedCreator = response.included.creator || []
        const pickIncludedUpdater = response.included.updater || []
        const pickIncludedWarehouse = response.included.warehouse || []
        const pickIncludedSupplier = response.included.supplier || []
        const pickIncludedDocuments = response.included.documents || []

        const getDataUser = (creatorId, included) => {
          let data = null
          const findUser = included[creatorId]
          if (findUser) {
            data = {
              id: findUser.attributes.id,
              name: findUser.attributes.name
            }
          }
          return data
        }

        const getDataSupplier = (supplierId, included) => {
          let data = null
          const findSupplier = included[supplierId]
          if (findSupplier) {
            data = {
              id: findSupplier.attributes.id,
              name: findSupplier.attributes.name
            }
          }
          return data
        }

        const getDataWarehouse = (warehouseId, included) => {
          let data = null
          const findWarehouse = included[warehouseId]
          if (findWarehouse) {
            data = {
              id: findWarehouse.attributes.id,
              name: findWarehouse.attributes.name
            }
          }
          return data
        }

        const hookDataDocumentId = (documentId, included) => {
          let data = null 
          const findDocument = included[documentId]
          if (findDocument) {
            data = findDocument.attributes
          }
          return data
        }

        const remapDataPackageShipment = dataPackageShipment.map((val) => {
          return {
            ...val.attributes,
            supplier: val.attributes.supplier_id !== null ? getDataSupplier(val.attributes.supplier_id, pickIncludedSupplier) : null,
            warehouse: val.attributes.warehouse_id !== null ? getDataWarehouse(val.attributes.warehouse_id, pickIncludedWarehouse) : null,
            documents: val.relationships.documents.length > 0 ? hookDataDocumentId(val.relationships.documents[0].id, pickIncludedDocuments) : null,
            creator: val.attributes.created_by ? getDataUser(val.attributes.created_by, pickIncludedCreator) : null,
            updater: val.attributes.updated_by ? getDataUser(val.attributes.updated_by, pickIncludedUpdater) : null,
          }
        })
        setPackageShipmentList(remapDataPackageShipment)
      } else {
        setPackageShipmentList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetPackageShipmentList()
    // eslint-disable-next-line
  }, [])

  const actions = {
    edit: (val) => {
      setModalFormPackageShipment(val)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('Package Shipment', val.id, val.name, deletePackageShipment, handleGetPackageShipmentList)
    },
    remove_handling_shipping: (val) => {
      const payload = {
      courier_name_slug: val.courier_name_slug,
      tracking_code: val.tracking_code,
      last_mile_courier: val.last_mile_courier,
      tracking_code_courier: val.tracking_code_courier,
      estimated_arrival: val.estimated_arrival,
      estimated_departure: val.estimated_departure,
      port_of_landing: val.port_of_landing,
      port_of_destination: val.port_of_destination,
      order_id: val.order_id
      }
      if (val.supplier_id !== null) {
        payload.supplier_id = null
      } else {
        payload.warehouse_id = null
      }
      modalDeleteDataUsePayload('Handling Shipment', val.id, payload, val.supplier_id !== null ? val.supplier.name : val.warehouse.name, updatePackageShipment, handleGetPackageShipmentList)
    },
    remove_shipping_document: (val) => {
      console.log(val)
      const payload = {
        documents: [val.documents.id],
        order_id: val.order_id
      }
      modalDeleteDataUsePayload('Shipping Label', val.id, payload, val.documents !== null ? val.documents.name : '', updatePackageShipmentDocument, handleGetPackageShipmentList)
    },
    print: (val) => {
      window.open(`https://api2.asiacommerce.net/api/v2/packages/shiping-label/${val.id}`, '_blank')
    },
    broadcast: (val) => {
      setModalFormBroadcast(true)
      setDetailData(val)
    },
    share: (val) => {
      setModalFormShareTracking(true)
      setDetailData(val)
    },
    detail: (val) => {
      navigate(`/order/${orderId}/package/${val.id}`)
    },
    handle_shipping: (val) => {
      setModalFormHandleShipment(true)
      setDetailData(val)
    },
    shipping_document: (val) => {
      setModalFormShippingDocument(true)
      setDetailData(val)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseFormPackageShipment = () => {
    setModalFormPackageShipment(false)
    setDetailData(null)
  }

  const onCloseFormHandleShipment = () => {
    setModalFormHandleShipment(false)
    setDetailData(null)
  }

  const onCloseFormShippingLabel = () => {
    setModalFormShippingDocument(false)
    setDetailData(null)
  }

  const onCloseFormBroadcastMessage = () => {
    setModalFormBroadcast(false)
    setDetailData(null)
  }

  const onCloseFormShareTracking = () => {
    setModalFormShareTracking(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={20}> 
        <Box>
          <Flex justify='flex-end' align='center' my={20}>
            <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setModalFormPackageShipment(true)}>Add Package Shipment</Button>
          </Flex>
        </Box>
        <Box my={30}>
          {loading ? <LoadingData /> : packageShipmentList.length > 0 ? <OrderPackageShipmentTable label={labelTable} data={packageShipmentList} actionMethod={handleAction} /> : <NoData />}
        </Box>
      </Box>
      <Modal opened={modalFormPackageShipment} onClose={onCloseFormPackageShipment} centered closeOnClickOutside={false} size='75%' title={<Text fw='Bold'>{detailData === null ? 'Create' : 'Update'} Package Shipment</Text>} withCloseButton={false}>
        <FormAdjustPackageShipment dataPackageShipment={detailData} onCloseForm={onCloseFormPackageShipment} reloadList={handleGetPackageShipmentList} />
      </Modal>
      <Modal opened={modalFormHandleShipment} onClose={onCloseFormHandleShipment} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Shipping Process</Text>} withCloseButton={false}>
        <FormAdjustHandleShipment dataHandleShipment={detailData} onCloseForm={onCloseFormHandleShipment} reloadList={handleGetPackageShipmentList} />
      </Modal>
      <Modal opened={modalFormShippingDocument} onClose={onCloseFormShippingLabel} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Attach Shipping Label Documents</Text>} withCloseButton={false}>
        <FormAdjustShippingDocument dataDocument={detailData} onCloseForm={onCloseFormShippingLabel} reloadList={handleGetPackageShipmentList} />
      </Modal>
      <Modal opened={modalFormBroadcast} onClose={onCloseFormBroadcastMessage} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Broadcast Shipment Info To WhatsApp</Text>} withCloseButton={false}>
        <FormBroadcastPackageShipment dataPackage={detailData} onCloseForm={onCloseFormBroadcastMessage} />
      </Modal>
      <Modal opened={modalFormShareTracking} onClose={onCloseFormShareTracking} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Share Tracking Link</Text>} withCloseButton={false}>
        <FormSharePackageShipment dataPackage={detailData} onCloseForm={onCloseFormShareTracking} />
      </Modal>
    </Box>
    
  )
}

export default OrderPackageShipment